module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAATFJREFUOE+dk8FtwjAUhr8XuPSWDZoNSBUOkEvNBKUb0E3aDdigbAAb4F6gUovkbkA3yK2XkFfZEFVAihTexZZ//9/z87OFQ6QDk3QippuVHddrTWN/aGypTNy73Xpdstw4gd4l0wXNSTY0U4H0GoCCTw79gTEiom0hH+vl2x6Qm9Zm7/tcWTkCKHyhJEAhwq0q3+Gi/uYxwra+syOAQrGDERVFR3gGxqKEjqiwQJjvKl6IiDuwFIjPTlDCXQBETFF6ojwdAK8iJFSM8HDhvrkEDZmMKM6PgKufSQDVOsSNgLZdOCvhKkCWm4XAQ1tzXZKkuUm71b6m01BhEtqozJr0MqII76Ap0tTE3RvmXit/eHTOFk37/gVkQzPmcAKU2WZtF60A4XsL1pt2iqm/7ynkF6FEe/+VemuZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theory/ic_class.png
// module id = 72
// module chunks = 0